import React from "react"
import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

const Seo = ({ title, description, image, canonical, article }) => (

  <StaticQuery
    query={query}
    render={({

      site: {
        siteMetadata: { siteUrl, defaultImage },
      },

      wp: {
        companyDetails: {
          companyDetails: { defaultTitle, defaultDescription, socialAccounts },
        }
      },

    }) => {
      const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: `${image || defaultImage}`,
        url: `${siteUrl}${canonical || "/"}`,
        canonical: `${siteUrl}${canonical || "/"}`,
      }

      //get Twitter handle
      function twitterUsernameFunction() {

        var twit = socialAccounts.filter(
          node => node.socialAccountDetails.name === "Twitter"
        )

        var twituser = twit[0].socialAccountDetails.handle

        if (twituser !== undefined) {
          return twituser
        } else {
          return
        }

      }

      const twitterUsername = twitterUsernameFunction()

      return (
        <>
          <Helmet
            title={seo.title}
          >
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            <link rel="canonical" href={seo.canonical} />
            {seo.url && <meta property="og:url" content={seo.url} />}
            {(article ? true : null) && (
              <meta property="og:type" content="article" />
            )}
            {seo.title && <meta property="og:title" content={seo.title} />}
            {seo.description && (
              <meta property="og:description" content={seo.description} />
            )}
            {seo.image && <meta property="og:image" content={seo.image} />}
            <meta name="twitter:card" content="summary_large_image" />
            {twitterUsername && (
              <meta name="twitter:creator" content={twitterUsername} />
            )}
            {seo.title && <meta name="twitter:title" content={seo.title} />}
            {seo.description && (
              <meta name="twitter:description" content={seo.description} />
            )}
            {seo.image && <meta name="twitter:image" content={seo.image} />}
            <link rel="stylesheet" href="https://use.typekit.net/sxv8amb.css"/>
          </Helmet>
        </>
      )
    }}
  />
)

export default Seo

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  canonical: PropTypes.string,
  article: PropTypes.bool,
}

Seo.defaultProps = {
  title: null,
  description: null,
  image: null,
  canonical: null,
  article: false,
}

const query = graphql`
  query Seo {
    site {
      siteMetadata {
        siteUrl
        defaultImage: image
      }
    }
    wp {
      companyDetails {
        companyDetails {
          defaultTitle: companyname
          defaultDescription: companydescription
          socialAccounts {
            socialAccountDetails {
              name
              handle
            }
          }
        }
      }
    }
  }
`